@if (isLoading$ | async) {
  <div class="flex justify-center items-center h-full">
    <p-progressSpinner></p-progressSpinner>
  </div>
} @else {
  <mnc-dmepos-auth-request-initial
    lazyComponent
    [tenantId]="tenantId"
    [member]="member"
    [inboundFaxData]="inboundFaxData"
    [tab]="tab"
    [authByProductId]="authorizationByProductId"
    (cancelRequest)="cancelRequest()"
    (goToHome)="goToHome()"
    (goToProviderDashboard)="goToProviderDashboard()"
    (goToAuthorization)="goToAuthorization($event)"
  ></mnc-dmepos-auth-request-initial>
}

